import { render, staticRenderFns } from "./CustomExports.vue?vue&type=template&id=65a3ab0f&"
import script from "./CustomExports.vue?vue&type=script&lang=js&"
export * from "./CustomExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports